<template>
  <div>
    <app-navigation class="pb-6"></app-navigation>
    <v-content transition="slide-x-transition" class="pb-6">
      <browser-alert></browser-alert>
      <router-view :key="$route.path"></router-view>
    </v-content>
    <v-footer
      :color="highContrast ? 'dark' : 'secondary'"
      fixed
      height="64"
      class="px-5 hidden-xs-only"
    >
      <p class="mb-0">&copy; {{ new Date().getFullYear() }} Unimed</p>
      <v-spacer></v-spacer>
      <v-img
        :src="logoPortalContrast"
        width="200"
        height="50"
        max-width="200"
        contain
      ></v-img>
    </v-footer>
  </div>
</template>

<script>
import AppNavigation from "@/components/AppNavigation";
import BrowserAlert from "@/components/BrowserAlert";
import ZitrusLogoContrast from "@/assets/logo_zitrus_branco.png";

import { createNamespacedHelpers } from "vuex";

const portalStore = createNamespacedHelpers("portal");

export default {
  name: "Portal",
  components: {
    AppNavigation,
    BrowserAlert
  },
  computed: {
    ...portalStore.mapState(["highContrast"])
  },
  data() {
    return {
      logoPortalContrast: ZitrusLogoContrast
    };
  }
};
</script>

<style>
.pb-6 {
  padding-bottom: 64px !important;
}
</style>
